;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/b/:blobId\",\"regex\":\"^/b/([^/]+)$\",\"paramNames\":[\"blobId\"],\"hasOptionalPrefix\":false},{\"path\":\"/b/:blobId/edit\",\"regex\":\"^/b/([^/]+)/edit$\",\"paramNames\":[\"blobId\"],\"hasOptionalPrefix\":false},{\"path\":\"/c/:namedId\",\"regex\":\"^/c/([^/]+)$\",\"paramNames\":[\"namedId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/all\"},{\"path\":\"/login\"},{\"path\":\"/new\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.6";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://efa48f40d44d8448145f39c181f9aa86@o4506435970662400.ingest.sentry.io/4506435972300800",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["localhost", /^\//, process.env.API],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
